var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUserCircle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320",
    transform: "translate(-1407 -152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    transform: "translate(1407 152)",
    fill: "#fff",
    stroke: "#ccc",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 32.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "user",
    d: "M55.481,9.519A32.5,32.5,0,0,0,9.518,55.481,32.5,32.5,0,0,0,55.481,9.519ZM16.293,56.162a16.457,16.457,0,0,1,32.414,0,28.629,28.629,0,0,1-32.414,0Zm5.873-27.742A10.334,10.334,0,1,1,32.5,38.754,10.345,10.345,0,0,1,22.166,28.421Zm29.839,25.1a20.3,20.3,0,0,0-11.8-13.247,14.142,14.142,0,1,0-15.412,0,20.294,20.294,0,0,0-11.8,13.247,28.691,28.691,0,1,1,39.011,0Zm0,0",
    transform: "translate(1407 152)",
    fill: "#8987C0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user_circle.f00103ed.svg";
export { ForwardRef as ReactComponent };